import { mergeAttributes } from '@tiptap/core'
import BulletList from '@tiptap/extension-bullet-list'

export const CustomBulletList = BulletList.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      dir: {
        default: null,
        parseHTML: element => element.getAttribute('dir'),
        renderHTML: attributes =>
          attributes.dir ? { dir: attributes.dir } : {},
      },
    }
  },

  // Ensure `dir` is forwarded to the rendered `<ul>`
  renderHTML({ HTMLAttributes }) {
    return [
      'ul',
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
      0,
    ]
  },
})
